/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Autocomplete,
} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { toast } from 'react-toastify';
import { DatePicker } from '@mui/x-date-pickers';
import { getPresentationLog } from '../../api/reportsApi';
import AppConst from '../AppLayout/const';
import { getDepartmentFilter } from '../../api/filterOptionsApi';
// Helper Functions
import { filterDepartmentOptions } from '../../helpers/filterFunctions';

export default function PresentationLogModal() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);

  const defaultFilter = {
    department: '',
  };

  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [departmentOptions, setDepartmentDrowndown] = useState([]);
  const [fromValue, setFromValue] = useState(moment().format('YYYY-MM-DD'));
  const [toValue, setToValue] = useState(moment().format('YYYY-MM-DD'));

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const loadDepartmentDropdown = async () => {
    const request = {
      keyword: '',
    };
    const reponse = await getDepartmentFilter(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = filterDepartmentOptions(data);

      setDepartmentDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);

      if (dropdownValue.length < 2) {
        setFilterForm({ ...filterForm, department: dropdownValue[0] });
      } else {
        setFilterForm({ ...filterForm, department: { label: 'ALL', value: null } });
      }
    }
  };

  useEffect(() => {
    if (toggleModal?.url === 'report/presentation_log') {
      setToggle(true);
      loadDepartmentDropdown();
    }
  }, [toggleModal]);

  const handleExport = async () => {
    try {
      toast.loading('Please wait ...');
      const res = await getPresentationLog({
        from: fromValue,
        to: toValue,
        department: filterForm?.department.value,
      });

      const { code, result, message } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();

      window.location.href = result;
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleSubmit = () => {
    handleExport(fromValue, toValue);
  };

  const handleChangeFrom = (value) => {
    setFromValue(moment(value).format('YYYY-MM-DD'));
  };

  const handleChangeTo = (value) => {
    setToValue(moment(value).format('YYYY-MM-DD'));
  };

  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };

  return (
    <Dialog open={toggle} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>Presentation Log</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              options={departmentOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={filterForm?.department}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              sx={{ backgroundColor: '#fff' }}
            />
          </Grid>
          <Grid lg={6}>
            <DatePicker
              label='from'
              views={['month', 'day', 'year']}
              value={fromValue}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='From' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeFrom(value)}
            />
          </Grid>
          <Grid lg={6}>
            <DatePicker
              label='to'
              views={['month', 'day', 'year']}
              value={toValue}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='To' size='small' fullWidth />}
              onChange={(value) => handleChangeTo(value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit}>Submit</Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
